var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tiptap',{attrs:{"content":_vm.content,"placeholder":_vm.placeholder,"extensions":_vm.extensions,"height":_vm.height},on:{"onUpdate":_vm.onEditorUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }